import React from 'react'
import { Link } from 'react-router-dom'

export default function Error() {
    return (
        <section className="flex flex-col justify-center items-center h-screen p-16 ">
            <h1 className="bg-red-400 text-3xl text-white text-center p-5 shadow shadow-lg border ">Sorry the page does not exist!</h1>
            <button className="bg-purple-800 text-white px-5 py-2 rounded mx-auto mt-10 ">
                <Link to="/">Back Home</Link>
            </button>
        </section>
    )
}
